const OpenEmailSvg = ({
  height = 22,
  width = 22,
  viewBox = '0 0 22 22',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M3.33333 8.33337L8.42303 12.1769L8.42473 12.1783C8.98987 12.5927 9.27261 12.8001 9.5823 12.8802C9.85602 12.951 10.1438 12.951 10.4175 12.8802C10.7274 12.8 11.011 12.592 11.5771 12.1769L16.6667 8.33337M16.5002 7.53291L11.8343 3.79718C11.255 3.33333 10.9651 3.10149 10.6429 3.00942C10.3587 2.92819 10.0577 2.92388 9.77127 2.99721C9.44669 3.08032 9.15073 3.30398 8.55877 3.75161L3.55794 7.5331C3.16983 7.82657 2.97603 7.97341 2.8361 8.15887C2.71217 8.32314 2.61981 8.50892 2.56354 8.70685C2.5 8.93032 2.5 9.17364 2.5 9.66022V14.8334C2.5 15.7669 2.5 16.2338 2.68166 16.5903C2.84144 16.9039 3.09623 17.1587 3.40983 17.3185C3.766 17.5 4.23249 17.5 5.16409 17.5H14.8359C15.7675 17.5 16.2333 17.5 16.5895 17.3185C16.9031 17.1587 17.1587 16.9037 17.3185 16.5901C17.5 16.234 17.5 15.7679 17.5 14.8363V9.60543C17.5 9.14114 17.5 8.90756 17.4406 8.69179C17.3876 8.49939 17.2996 8.31805 17.1825 8.15644C17.0504 7.97401 16.8674 7.82693 16.5002 7.53291Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OpenEmailSvg;
